import React, {useEffect, useState} from 'react';
import GoBack from "../subsidiary/GoBack/GoBack";
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";
import {styled} from '@mui/material/styles';
import styles from './Settings.module.css'
import {useDispatch, useSelector} from "react-redux";
import {changeNotifications, getUserData} from "../Profile/profileSlice";


const AntSwitch = styled(Switch)(({theme}) => ({
    width: 60,
    height: 30,
    padding: 0,
    borderRadius: 25,
    display: 'flex',
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 15,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(9px)',
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 3,
        '&.Mui-checked': {
            transform: 'translateX(32px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: '#F36A5B',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 24,
        height: 24,
        borderRadius: 25,
        transition: theme.transitions.create(['width'], {
            duration: 200,
        }),
    },
    '& .MuiSwitch-track': {
        border: '1px solid #F36A5B',
        borderRadius: 25,
        opacity: 1,
        backgroundColor: '#fff',
        boxSizing: 'border-box',
    },
}));

function Notification(props) {
    const dispatch = useDispatch()
    const token = useSelector(state => state.loginSlice.token)
    const user = useSelector(state => state.profileSlice.user)

    const [notifications, setNotification] = useState([]);

    const role = user?.role;
    const isAdminOrModerator = !!(
        role && (
            role.administrator ||
            role.moderator ||
            (Array.isArray(role) && (role.includes('administrator') || role.includes('moderator')))
        )
    );

    useEffect(() => {
        dispatch(getUserData({token}))
    }, [dispatch, token])

    useEffect(() => {
        const raw = user?.notifications;
        let list = [];
        if (Array.isArray(raw)) {
            list = [...raw];
        } else if (raw && typeof raw === 'object') {
            list = Object.values(raw);
        }

        // Default policy:
        // - admins/moderators: email ON by default
        // - regular users: email OFF by default
        if (list.includes('email_off')) {
            list = list.filter(item => item !== 'email');
        } else if (list.includes('email')) {
            list = list.filter(item => item !== 'email_off');
        } else if (isAdminOrModerator) {
            list.push('email');
        }

        setNotification(list);
    }, [user, isAdminOrModerator])


    const handleClick = (type) => {
        const state = [...notifications];
        if (!state.includes(type)) {
            state.push(type);
        } else {
            state.splice(state.indexOf(type), 1);
        }

        setNotification(state);
    }

    return (
        <section className='main'>
            <GoBack text='Назад'/>
            <div className='content-wrapper'>
                <div className='page-title-container'>
                    <h1 className='page-title'>
                        Настроить уведомления
                    </h1>
                </div>
                <div className={styles.formCtrl}>
                    <div className={styles.notificationItem}>
                        <AntSwitch
                            onChange={() => handleClick('show')}
                            checked={notifications.includes('show')}
                            inputProps={{'aria-label': 'ant design'}}/>
                        <span className={styles.notificationItemText}>Показывать уведомления</span>
                    </div>
                    <div className={styles.notificationItem}>
                        <AntSwitch
                            onChange={() => handleClick('helpers')}
                            checked={notifications.includes('helpers')}
                            inputProps={{'aria-label': 'ant design'}}/>
                        <span className={styles.notificationItemText}>Подсказки</span>
                    </div>
                    <div className={styles.notificationItem}>
                        <AntSwitch
                            onChange={() => handleClick('disturb')}
                            checked={notifications.includes('disturb')}
                            inputProps={{'aria-label': 'ant design'}}/>
                        <span className={styles.notificationItemText}>Не беспокоить</span>
                    </div>
                    <Button style={{color: '#fff', width: '266px'}} className={styles.sendBtn}
                        onClick={() => dispatch(changeNotifications({token, notifications}))}
                    >
                        Сохранить
                    </Button>
                </div>
            </div>
        </section>
    );
}

export default Notification;